import { createStore } from "vuex";
import axios from "axios";
import { getSiteLanList, getSiteSettings } from "@/api/index";
import { getOperationRecord, setOperationRecord } from "@/utils/localStorage";

export default createStore({
  state: {
    siteCode: "",
    checkedQuestion: null,
    baseUrl: "",
    siteList: [],
    siteSetting: [],
    pageLoading: false,
    operationRecord: getOperationRecord(),
  },
  getters: {},
  mutations: {
    SET_SITECODE: (state, code) => {
      state.siteCode = code;
    },
    Set_BaseUrl: (state, url) => {
      state.baseUrl = url;
    },
    SET_CHECKED_QUES: (state, checkedQuestion) => {
      state.checkedQuestion = checkedQuestion;
    },
    SET_SITELIST: (state, list) => {
      state.siteList = list;
    },
    SET_SITESETTING: (state, sets) => {
      sets = sets.map((el) => {
        return {
          ...el,
          content: JSON.parse(el.content),
        };
      });
      state.siteSetting = sets;
    },
    SET_PAGELOADING: (state, loading) => {
      state.pageLoading = loading;
    },
    /**
     * 用户操作记录
     * 1. 由于操作日志是本身是树结构，则每次选择切换问题时去队列树中查找如未找到，则找到对应父节点，找到后挂载在父节点下，
     * 如果未找到当前问题、也未找到父节点，则默认创建新的树
     * 2. 返回至产品页清空队列
     * @param state
     * @param queue
     * @constructor Operation record
     */
    SET_OPERATION_RECORD: (state, record) => {
      setOperationRecord(record);
      state.operationRecord = record;
    },
  },
  actions: {
    onGetBasic({ commit }) {
      return new Promise((resolve) => {
        axios
          .get("/troubleshooting-web/config/config.json")
          .then(async (res) => {
            commit("Set_BaseUrl", res.data.baseUrl);
            resolve(res.data.baseUrl);
          });
      });
    },
    onGetSiteList({ commit }) {
      return new Promise((resolve) => {
        getSiteLanList().then((res) => {
          commit("SET_SITELIST", res);
          resolve(res);
        });
      });
    },
    onGetSiteSettings({ commit }) {
      return new Promise((resolve) => {
        getSiteSettings().then((res) => {
          commit("SET_SITESETTING", res);
          resolve(res);
        });
      });
    },
  },
  modules: {},
});
